import { SPEED_OPTIONS } from "../constants";

interface ControlBarProps {
  running: boolean;
  completed: boolean;
  currentTimeLabel: string;
  step: number;
  totalSteps: number;
  speedMultiplier: number;
  onStart: () => void;
  onReset: () => void;
  onSpeedChange: (speed: number) => void;
}

export default function ControlBar({
  running,
  completed,
  currentTimeLabel,
  step,
  totalSteps,
  speedMultiplier,
  onStart,
  onReset,
  onSpeedChange,
}: ControlBarProps) {
  return (
    <div className="w-full rounded-2xl border border-slate-200 bg-white/95 p-4 shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <button
            type="button"
            disabled={running || completed}
            onClick={onStart}
            className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-emerald-500 disabled:cursor-not-allowed disabled:bg-slate-300"
          >
            Start Simulation
          </button>
          <button
            type="button"
            onClick={onReset}
            className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
          >
            Reset
          </button>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-xs font-medium uppercase tracking-wide text-slate-500">Speed</span>
          <select
            value={speedMultiplier}
            onChange={(event) => onSpeedChange(Number(event.target.value))}
            className="rounded-md border border-slate-300 bg-white px-2 py-1.5 text-sm text-slate-800"
          >
            {SPEED_OPTIONS.map((speed) => (
              <option key={speed.label} value={speed.value}>
                {speed.label}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-wrap items-center gap-6">
          <div>
            <p className="text-xs uppercase tracking-wide text-slate-500">Current Time</p>
            <p className="text-lg font-semibold text-slate-800">{currentTimeLabel}</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-wide text-slate-500">Timestep</p>
            <p className="text-lg font-semibold text-slate-800">
              {Math.min(step, totalSteps)} / {totalSteps}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
